class CountryService extends BaseService
	@register()
	@inject '$rootScope',
		'LanguageService'
		'MessageTerminal'
		'BACKEND_COUNTRY_CODES'

	initialize: ->
		@countries = @getCountriesFromCodes(@LanguageService.getDisplayLanguage().language)
		@MessageTerminal.on(
			@$rootScope,
			@MessageTerminal.events.DISPLAY_LANGUAGE,
			(data) => @countries = @getCountriesFromCodes(data.language)
		)

	getCountriesFromCodes: (language) ->
		countries = []

		try
			regionNames = new Intl.DisplayNames([language], {type: 'region'})
		catch error
			regionNames = null

		for countryCode in @BACKEND_COUNTRY_CODES
			countryName = regionNames?.of(countryCode) ? countryCode

			countries.push({code: countryCode, name: countryName})

		return countries

